module.exports = __webpack_public_path__ + "style/img/Group 2175.365863b5.png";